var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVRentals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 62,
    viewBox: "0 0 80 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_648_80)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.751 0.247559H0.248779V56.3192H79.751V0.247559Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.982 6.93286H7.01807V49.641H72.982V6.93286Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01795 6.93286L0.248779 0.247559",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9819 6.93286L79.7511 0.247559",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9819 49.6339L79.7511 56.3192",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01795 49.6339L0.248779 56.3192",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6191 15.9244C15.3771 15.9244 15.9915 15.3132 15.9915 14.5591C15.9915 13.805 15.3771 13.1937 14.6191 13.1937C13.8612 13.1937 13.2468 13.805 13.2468 14.5591C13.2468 15.3132 13.8612 15.9244 14.6191 15.9244Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1516 15.9244C23.9095 15.9244 24.5239 15.3132 24.5239 14.5591C24.5239 13.805 23.9095 13.1937 23.1516 13.1937C22.3937 13.1937 21.7793 13.805 21.7793 14.5591C21.7793 15.3132 22.3937 15.9244 23.1516 15.9244Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5491 15.9244C32.307 15.9244 32.9214 15.3132 32.9214 14.5591C32.9214 13.805 32.307 13.1937 31.5491 13.1937C30.7912 13.1937 30.1768 13.805 30.1768 14.5591C30.1768 15.3132 30.7912 15.9244 31.5491 15.9244Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0889 15.9244C40.8468 15.9244 41.4612 15.3132 41.4612 14.5591C41.4612 13.805 40.8468 13.1937 40.0889 13.1937C39.331 13.1937 38.7166 13.805 38.7166 14.5591C38.7166 15.3132 39.331 15.9244 40.0889 15.9244Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4863 15.9244C49.2442 15.9244 49.8587 15.3132 49.8587 14.5591C49.8587 13.805 49.2442 13.1937 48.4863 13.1937C47.7284 13.1937 47.114 13.805 47.114 14.5591C47.114 15.3132 47.7284 15.9244 48.4863 15.9244Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0261 15.9244C57.784 15.9244 58.3985 15.3132 58.3985 14.5591C58.3985 13.805 57.784 13.1937 57.0261 13.1937C56.2682 13.1937 55.6538 13.805 55.6538 14.5591C55.6538 15.3132 56.2682 15.9244 57.0261 15.9244Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5657 15.9244C66.3236 15.9244 66.938 15.3132 66.938 14.5591C66.938 13.805 66.3236 13.1937 65.5657 13.1937C64.8078 13.1937 64.1934 13.805 64.1934 14.5591C64.1934 15.3132 64.8078 15.9244 65.5657 15.9244Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6191 24.8241C15.3771 24.8241 15.9915 24.2128 15.9915 23.4587C15.9915 22.7047 15.3771 22.0934 14.6191 22.0934C13.8612 22.0934 13.2468 22.7047 13.2468 23.4587C13.2468 24.2128 13.8612 24.8241 14.6191 24.8241Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1516 24.8241C23.9095 24.8241 24.5239 24.2128 24.5239 23.4587C24.5239 22.7047 23.9095 22.0934 23.1516 22.0934C22.3937 22.0934 21.7793 22.7047 21.7793 23.4587C21.7793 24.2128 22.3937 24.8241 23.1516 24.8241Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5491 24.8241C32.307 24.8241 32.9214 24.2128 32.9214 23.4587C32.9214 22.7047 32.307 22.0934 31.5491 22.0934C30.7912 22.0934 30.1768 22.7047 30.1768 23.4587C30.1768 24.2128 30.7912 24.8241 31.5491 24.8241Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0889 24.8241C40.8468 24.8241 41.4612 24.2128 41.4612 23.4587C41.4612 22.7047 40.8468 22.0934 40.0889 22.0934C39.331 22.0934 38.7166 22.7047 38.7166 23.4587C38.7166 24.2128 39.331 24.8241 40.0889 24.8241Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4863 24.8241C49.2442 24.8241 49.8587 24.2128 49.8587 23.4587C49.8587 22.7047 49.2442 22.0934 48.4863 22.0934C47.7284 22.0934 47.114 22.7047 47.114 23.4587C47.114 24.2128 47.7284 24.8241 48.4863 24.8241Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0261 24.8241C57.784 24.8241 58.3985 24.2128 58.3985 23.4587C58.3985 22.7047 57.784 22.0934 57.0261 22.0934C56.2682 22.0934 55.6538 22.7047 55.6538 23.4587C55.6538 24.2128 56.2682 24.8241 57.0261 24.8241Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5657 24.8241C66.3236 24.8241 66.938 24.2128 66.938 23.4587C66.938 22.7047 66.3236 22.0934 65.5657 22.0934C64.8078 22.0934 64.1934 22.7047 64.1934 23.4587C64.1934 24.2128 64.8078 24.8241 65.5657 24.8241Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6191 33.7166C15.3771 33.7166 15.9915 33.1053 15.9915 32.3512C15.9915 31.5971 15.3771 30.9858 14.6191 30.9858C13.8612 30.9858 13.2468 31.5971 13.2468 32.3512C13.2468 33.1053 13.8612 33.7166 14.6191 33.7166Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1516 33.7166C23.9095 33.7166 24.5239 33.1053 24.5239 32.3512C24.5239 31.5971 23.9095 30.9858 23.1516 30.9858C22.3937 30.9858 21.7793 31.5971 21.7793 32.3512C21.7793 33.1053 22.3937 33.7166 23.1516 33.7166Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5491 33.7166C32.307 33.7166 32.9214 33.1053 32.9214 32.3512C32.9214 31.5971 32.307 30.9858 31.5491 30.9858C30.7912 30.9858 30.1768 31.5971 30.1768 32.3512C30.1768 33.1053 30.7912 33.7166 31.5491 33.7166Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0889 33.7166C40.8468 33.7166 41.4612 33.1053 41.4612 32.3512C41.4612 31.5971 40.8468 30.9858 40.0889 30.9858C39.331 30.9858 38.7166 31.5971 38.7166 32.3512C38.7166 33.1053 39.331 33.7166 40.0889 33.7166Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4863 33.7166C49.2442 33.7166 49.8587 33.1053 49.8587 32.3512C49.8587 31.5971 49.2442 30.9858 48.4863 30.9858C47.7284 30.9858 47.114 31.5971 47.114 32.3512C47.114 33.1053 47.7284 33.7166 48.4863 33.7166Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0261 33.7166C57.784 33.7166 58.3985 33.1053 58.3985 32.3512C58.3985 31.5971 57.784 30.9858 57.0261 30.9858C56.2682 30.9858 55.6538 31.5971 55.6538 32.3512C55.6538 33.1053 56.2682 33.7166 57.0261 33.7166Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5657 33.7166C66.3236 33.7166 66.938 33.1053 66.938 32.3512C66.938 31.5971 66.3236 30.9858 65.5657 30.9858C64.8078 30.9858 64.1934 31.5971 64.1934 32.3512C64.1934 33.1053 64.8078 33.7166 65.5657 33.7166Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6191 42.6162C15.3771 42.6162 15.9915 42.0049 15.9915 41.2509C15.9915 40.4968 15.3771 39.8855 14.6191 39.8855C13.8612 39.8855 13.2468 40.4968 13.2468 41.2509C13.2468 42.0049 13.8612 42.6162 14.6191 42.6162Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1516 42.6162C23.9095 42.6162 24.5239 42.0049 24.5239 41.2509C24.5239 40.4968 23.9095 39.8855 23.1516 39.8855C22.3937 39.8855 21.7793 40.4968 21.7793 41.2509C21.7793 42.0049 22.3937 42.6162 23.1516 42.6162Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5491 42.6162C32.307 42.6162 32.9214 42.0049 32.9214 41.2509C32.9214 40.4968 32.307 39.8855 31.5491 39.8855C30.7912 39.8855 30.1768 40.4968 30.1768 41.2509C30.1768 42.0049 30.7912 42.6162 31.5491 42.6162Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0889 42.6162C40.8468 42.6162 41.4612 42.0049 41.4612 41.2509C41.4612 40.4968 40.8468 39.8855 40.0889 39.8855C39.331 39.8855 38.7166 40.4968 38.7166 41.2509C38.7166 42.0049 39.331 42.6162 40.0889 42.6162Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4863 42.6162C49.2442 42.6162 49.8587 42.0049 49.8587 41.2509C49.8587 40.4968 49.2442 39.8855 48.4863 39.8855C47.7284 39.8855 47.114 40.4968 47.114 41.2509C47.114 42.0049 47.7284 42.6162 48.4863 42.6162Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0261 42.6162C57.784 42.6162 58.3985 42.0049 58.3985 41.2509C58.3985 40.4968 57.784 39.8855 57.0261 39.8855C56.2682 39.8855 55.6538 40.4968 55.6538 41.2509C55.6538 42.0049 56.2682 42.6162 57.0261 42.6162Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5657 42.6162C66.3236 42.6162 66.938 42.0049 66.938 41.2509C66.938 40.4968 66.3236 39.8855 65.5657 39.8855C64.8078 39.8855 64.1934 40.4968 64.1934 41.2509C64.1934 42.0049 64.8078 42.6162 65.5657 42.6162Z",
    fill: "white",
    fillOpacity: 0.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5815 56.3192V61.7523H52.4611V56.3192",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_648_80"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVRentals);
export default __webpack_public_path__ + "static/media/V Rentals.d930788e62893cc2fda38200ac95b2b7.svg";
export { ForwardRef as ReactComponent };